module.exports = __webpack_public_path__ + "static/img/whatsapp.b4f373b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp.webp
// module id = 9arV
// module chunks = 1